import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { Suspense } from "react";

const RouterDevTools = React.lazy(() =>
  import("@tanstack/router-devtools").then((res) => ({
    default: res.TanStackRouterDevtools,
  })),
);

export const DevTools = () => {
  if (!import.meta.env.DEV) return null;
  return (
    <>
      <Suspense>
        <RouterDevTools position="bottom-right" />
      </Suspense>
      <ReactQueryDevtools />
    </>
  );
};
